import type { ComponentPropsWithoutRef } from 'react';
import { ChevronDown } from 'lucide-react';
export default function BorderlessSelect(props: ComponentPropsWithoutRef<'select'>) {
 return <span className="tk-filter-select"><select {...props}/><ChevronDown aria-hidden="true" className="pointer-events-none absolute right-1 h-3.5 w-3.5 text-primary"/></span>;
}
